import { defineMessages, type MessageDescriptor } from 'react-intl';

type MessageKeys = 'attachmentsHeading' | 'outputHeading';

const messages: Record<MessageKeys, MessageDescriptor> = defineMessages({
	attachmentsHeading: {
		id: 'ai-mate.conversation-assistant.split-layout.default-right-panel.attachments-heading-non-final',
		defaultMessage: 'Attachments',
		description: 'Heading for the list of sources used to generate the chat result.',
	},
	outputHeading: {
		id: 'ai-mate.conversation-assistant.split-layout.default-right-panel.output-heading-non-final',
		defaultMessage: 'Output',
		description: 'Heading for the list of output artefacts produced by the chat result.',
	},
});

export default messages;
